import api from './api';

export interface SavedJob {
  saved_id: number;
  saved_at: string;
  id: number;
  title: string;
  company_name: string;
  location: string;
  salary_min?: number;
  salary_max?: number;
  job_type?: string;
  work_time?: string;
  work_field?: string;
  company_activity?: string;
  description?: string;
  requirements?: string;
  employer_id: number;
  employer_email?: string;
  employer_phone?: string;
  employer_logo?: string;
  created_at: string;
  updated_at: string;
}

class SavedJobService {
  // Save a job
  async saveJob(jobId: number): Promise<any> {
    const response = await api.post(`/saved-jobs/${jobId}`);
    return response.data;
  }

  // Unsave a job
  async unsaveJob(jobId: number): Promise<any> {
    const response = await api.delete(`/saved-jobs/${jobId}`);
    return response.data;
  }

  // Check if a job is saved
  async isJobSaved(jobId: number): Promise<boolean> {
    const response = await api.get(`/saved-jobs/check/${jobId}`);
    return response.data.isSaved;
  }

  // Get all saved jobs with full details
  async getMySavedJobs(): Promise<SavedJob[]> {
    const response = await api.get('/saved-jobs/my/jobs');
    return response.data.data;
  }

  // Get saved job IDs only
  async getMySavedJobIds(): Promise<number[]> {
    const response = await api.get('/saved-jobs/my/ids');
    return response.data.data;
  }

  // Get count of saved jobs
  async getSavedJobsCount(): Promise<number> {
    const response = await api.get('/saved-jobs/my/count');
    return response.data.count;
  }

  // Toggle save status (save if not saved, unsave if saved)
  async toggleSaveJob(jobId: number, isSaved: boolean): Promise<any> {
    if (isSaved) {
      return this.unsaveJob(jobId);
    } else {
      return this.saveJob(jobId);
    }
  }
}

const savedJobService = new SavedJobService();
export default savedJobService;

